export default __webpack_public_path__ + "static/media/level-3.55cac409.png";